import React from "react"
import makeStyles from "@mui/styles/makeStyles"
import { connect } from "react-redux"
import DispatchTable from "./Product/DispatchTable"
import HubDispatchTable from "./Hub/HubDispatchTable"
import { updateDispatchTypeFilter } from "../../actions/Dispatch/dispatch"

const useClasses = makeStyles(() => ({
    container: {
        width: "100%"
    }
}))

const DispatchError = (props) => {
    const {
        hubs=false,
        selectedTypeFilter,
        dispatchDataError,
        updateDispatchTypeFilter,
        productTypeOptions
    } = props

    const classes = useClasses()
    const storage = JSON.parse(localStorage.getItem("searchValue"))
    const searchFilter = (storage && storage.dispatchToDo)?storage.dispatchToDo:""

    const _onProductTypeChange = (value) => {
        updateDispatchTypeFilter(value)
    }

    return (
        <div className={classes.container}>
            {
                !hubs &&
                <DispatchTable
                    canOpen={false}
                    tableType="error"
                    dispatchData={dispatchDataError}
                    selectedType={selectedTypeFilter}
                    onProductTypeChange={_onProductTypeChange}
                    searchFilter={searchFilter}
                    storageIndex="dispatchError"
                    productTypeOptions={productTypeOptions}
                />
            }
            {
                hubs &&
                <HubDispatchTable
                    canOpen={false}
                    tableType="error"
                    selectedType={selectedTypeFilter}
                    onProductTypeChange={_onProductTypeChange}
                    searchFilter={searchFilter}
                    storageIndex="dispatchError"
                />
            }
        </div>
    )
}

export default connect((state) => {
    return {
        date: state.dispatch.date,
        dispatchDataError: state.dispatch.dispatchDataError,
        selectedTypeFilter: state.dispatch.selectedTypeFilter,
        productTypeOptions: state.dispatch.productTypeOptions
    }
}, {
    updateDispatchTypeFilter
})(DispatchError)

